const studies = [
  {
    header: "Journal of Minimally Invasive Gynecology",
    date: "July 2026",
    studyurl: "https://pubmed.ncbi.nlm.nih.gov/42392355/",
    title:
      "vNOTES vs Total Laparoscopic Hysterectomy: A Randomized Controlled Trial of Pain, Opioid Use, and Quality of Recovery",
    doctors: "Acil F, Dedeoğlu A, Andıç O, et al.",
    content:
      "A striking finding of this study was the absence of postoperative rescue opioid administration in the vNOTES group, whereas all participants in the TLH group received postoperative rescue opioid analgesia according to the predefined protocol.",
  },
  {
    header: "British Journal of Obstetrics and Gynaecology",
    date: "May 2026",
    studyurl: "https://pubmed.ncbi.nlm.nih.gov/42137913/",
    title:
      "Vaginal Hysterectomy Versus Vaginal Assisted Natural Orifice Transluminal Endoscopic Surgery Hysterectomy; Results of a Randomised Controlled Trial",
    doctors: "Bekkers IPW, Wintraecken FRM, Smeets NAC, et al.",
    content:
      "This first single-blind, multicentre RCT comparing VANH with VH demonstrates a significantly higher rate of SDD [same day discharge] in the VANH group, along with several peri-operative advantages.",
  },
  {
    header: "Minimally Invasive Therapy and Allied Technologies",
    date: "February 2026",
    studyurl: "https://pubmed.ncbi.nlm.nih.gov/41358625/",
    title:
      "Vaginal natural orifice transluminal endoscopic surgery versus conventional laparoscopy for salpingectomy: a comparative analysis of sexual function, dyspareunia, and perioperative outcomes",
    doctors: "Akpak YK, Kanmaz AG, Töz E, Kıncı MF, Baekelandt J.",
    content:
      "vNOTES salpingectomy demonstrates perioperative advantages over laparoscopy without adversely affecting sexual function. It represents a safe and effective alternative for appropriately selected patients.",
  },
  {
    header: "Surgical Oncology",
    date: "February 2026",
    studyurl: "https://pubmed.ncbi.nlm.nih.gov/41506040/",
    title:
      "Risk reduction bilateral salpingo-oophorectomy with vNOTES: A new era in cancer prevention strategies",
    doctors: "Pellisé-Tintoré M, Gaillard T, Laas E, et al.",
    content:
      "vNOTES represents a promising, minimally invasive approach for prophylactic adnexectomy in BRCA-mutated patients, offering advantages such as reduced postoperative pain, faster recovery, and minimal scarring.",
  },
  {
    header: "Journal of Clinical Medicine",
    date: "August 2025",
    studyurl: "https://pubmed.ncbi.nlm.nih.gov/40869538/",
    title:
      "Vaginal Natural Orifice Transluminal Endoscopic Surgery (vNOTES) for Gynecological Procedures in Obese Patients: A Systematic Review",
    doctors: "Koulakmanidis AM, Vrysis C, Zacharakis D, et al.",
    content:
      "The technique was associated with low rates of intraoperative and postoperative complications and demonstrated statistically significant improvements in perioperative outcomes compared to traditional laparoscopic approaches.",
  },
  {
    header: "British Journal of Gynaecology",
    date: "March 2025",
    studyurl: "https://pubmed.ncbi.nlm.nih.gov/39552409/",
    title:
      "Intra- and Postoperative Complications in 4565 vNOTES Hysterectomies: International Registry Cohort Study",
    doctors: "Stuart A, Wagenius J, Badiglian-Filho L, et al.",
    content:
      "The intra- and postoperative complication and infection rates reported are lower or in the same range as other minimally invasive techniques, and the conversion rate to laparotomy was very low (0.2%).",
  },
  {
    header: "Journal of Minimally Invasive Gynecology",
    date: "January 2025",
    studyurl: "https://pubmed.ncbi.nlm.nih.gov/39218298/",
    title:
      "A Case Control Study of vNOTES Versus Conventional Laparoscopic Salpingectomy for Ectopic Pregnancy",
    doctors: "Yoong W, Ho J, Mathieu V, Wylie S, Lodhi W, Rouabhi S.",
    content:
      "Patients undergoing vNOTES have shorter intraoperative times and length of stays, less postoperative pain, and more rapid recovery, which help mitigate higher costs incurred by commercial kits.",
  },
  {
    header:
      "European Journal of Obstetrics & Gynecology and Reproductive Biology",
    date: "December 2024",
    studyurl: "https://pubmed.ncbi.nlm.nih.gov/39488140/",
    title:
      "Conventional vaginal approach vs. transvaginal natural orifice transluminal endoscopic surgery for treating apical prolapse, a randomized controlled study",
    doctors:
      "Lowenstein L, Mor O, Matanes E, Justman N, Stuart A, Baekelandt J.",
    content:
      "vNOTES hysterectomy with USLS has lower surgical times than conventional vaginal hysterectomy with USLS, lower blood loss and less adverse events.",
  },
  //
  // added 01 october 2024
  {
    header: "AJOG Global Reports",
    date: "February 2024",
    studyurl: "https://pubmed.ncbi.nlm.nih.gov/38440153/",
    title:
      "Systematic review and meta-analysis of vaginal natural orifice transluminal endoscopic surgery vs laparoscopic hysterectomy",
    doctors: "Marchand GJ, Masoud AT, Ulibarri H, et al.",
    content:
      "When evaluating the latest data, it seems that vaginal natural orifice transluminal endoscopic surgery techniques may have some advantages over conventional laparoscopic hysterectomy techniques.",
  },
  // added 01 october 2024
  {
    header: "Archives of Gynecology and Obstetrics",
    date: "February 2024",
    studyurl: "https://pubmed.ncbi.nlm.nih.gov/37880384/",
    title:
      "vNOTES (vaginal natural orifice transluminal surgery) gynecologic procedures in morbidly and super-morbidly obese women: five year experience.",
    doctors: "Burnett AF, Pitman TC, Baekelandt JF.",
    content:
      "vNOTES approach is feasible in morbidly obese women and may have distinct advantages over conventional laparoscopic, vaginal or open techniques.",
  },
  {
    header: "Journal of Minimally Invasive Gynecology",
    date: "November 2023",
    studyurl: "https://pubmed.ncbi.nlm.nih.gov/37422053/",
    title:
      "Comparing vNOTES Hysterectomy with Laparoscopic Hysterectomy for Large Uteri",
    doctors: "Kheirbek N, Delporte V, El Hajj H, et al.",
    content:
      "Compared with the laparoscopic approach, vNOTES hysterectomy for large uteri (>280 g) is associated with decreased OT (operative time), a shorter hospital stay, and increased performance in the ambulatory setting.",
  },
  // added 01 october 2024
  {
    header: "Journal of Minimally Invasive Gynecology",
    date: "July 2023",
    studyurl: "https://pubmed.ncbi.nlm.nih.gov/36966920/",
    title:
      "Cumulative Sum Analysis of Learning Curve Process for Vaginal Natural Orifice Transluminal Endoscopic Surgery Hysterectomy",
    doctors: "Mereu L, Pecorino B, Ferrara M, et al.",
    content:
      "vNOTES hysterectomy is a feasible and reproducible approach for benign indications with a short learning curve and low rate of perioperative complications.",
  },
  {
    header: "Archives of Gynecology and Obstetrics",
    date: "April 2023",
    studyurl: "https://pubmed.ncbi.nlm.nih.gov/36445449/",
    title:
      'Implementing the transvaginal natural orifice transluminal endoscopic surgery (vNOTES) "first" strategy in benign gynecological surgeries',
    doctors: "Tekin AB, Yassa M, Kaya C, et al.",
    content:
      "Implementing the vNOTES technique as an initial approach for all benign gynecological surgeries seems feasible, safe and satisfactory, even in those with a non-prolapsed or enlarged uterus and those that have previously undergone abdominal surgery.",
  },
  {
    header:
      "European Journal of Obstetrics \u0026 Gynecology and Reproductive Biology",
    date: "August 2021",
    studyurl: "https://pubmed.ncbi.nlm.nih.gov/34237485/",
    title:
      "Consensus on safe implementation of vaginal natural orifice transluminal endoscopic surgery (vNOTES)",
    doctors:
      "Kapurubandara S, Lowenstein L, Salvay H, Herijgers A, King J, Baekelandt J.",
    content:
      "...this statement provides an appropriate guidance to the safe implementation of vNOTES into gynaecological practice.",
  },
  {
    header: "British Journal of Obstetrics and Gynaecology",
    date: "July 2021",
    studyurl:
      "https://obgyn.onlinelibrary.wiley.com/doi/10.1111/1471-0528.16838",
    title:
      "Adnexectomy by vaginal Natural Orifice Transluminal Endoscopic Surgery versus laparoscopy: results of a first randomised controlled trial (NOTABLE\xa0trial)",
    doctors: "Baekelandt J, De Mulder PA, Le Roy I, et al.",
    content:
      "vNOTES is non-inferior to laparoscopy for a successful adnexectomy without conversion.",
  },
  {
    header:
      "European Journal of Obstetrics \u0026 Gynecology and Reproductive Biology",
    date: "April 2021",
    studyurl: "https://doi.org/10.1016/j.ejogrb.2021.03.040",
    title:
      "Transvaginal natural orifice transluminal endoscopic versus conventional vaginal hysterectomy with uterosacral ligament suspension for apical compartment prolapse",
    doctors:
      "Aharoni S, Matanes E, Lauterbach R, Mor O, Weiner Z, Lowenstein L.",
    content:
      "This retrospective study demonstrates the advantages of the vNOTES approach for hysterectomy with USLS, ... particularly the avoidance of ureteral obstruction.",
  },
  {
    header: "British Journal of Obstetrics and Gynaecology",
    date: "January 2019",
    studyurl: "https://doi.org/10.1111/1471-0528.15504",
    title:
      "Hysterectomy by transvaginal natural orifice transluminal endoscopic surgery versus laparoscopy as a day-care procedure: a randomised controlled trial",
    doctors: "Baekelandt JF, De Mulder PA, Le Roy I, et al.",
    content:
      "Besides avoiding visible scars and while being non-inferior to TLH [Total Laparoscopic Hysterectomy], vNOTES allows more women to undergo hysterectomy as a day-care surgical procedure.",
  },
];

export default studies;
